const BASE_URL = process.env.REACT_APP_BACKEND_URL;

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, { credentials: 'include', ...options });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`API ${res.status}: ${path} — ${body}`);
  }
  return res.json();
}

export function getAuthorities() {
  return request('/api/authorities');
}

export function getAuthority(id) {
  return request(`/api/authorities/${id}`);
}

export function getIndicesSummary() {
  return request('/api/indices/summary');
}

export function getGraph() {
  return request('/api/graph');
}

export function getDashboard() {
  return request('/api/dashboard');
}

export function getReport(id) {
  return request(`/api/report/${id}`);
}

export function adminRefresh(token) {
  return request('/api/admin/refresh', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function getIndexHistory() {
  return request('/api/index-history');
}

// ── LA microsites (Phase 4) ──────────────────────────────────────────────────
export function getLADirectory() {
  return request('/api/la/directory');
}

export function getLAIdentity(slug) {
  return request(`/api/la/${encodeURIComponent(slug)}`);
}

// ── Combined Authority consolidated payload (Feb 2026) ───────────────────────
// One call returns the CA metadata + every constituent LA's full identity
// payload + premises-weighted aggregates. Replaces the 5-7 round-trip client
// fan-out previously used by Reports.jsx → buildCAReport().
export function getCAConsolidated(caId) {
  return request(`/api/ca/${encodeURIComponent(caId)}`);
}

// ── Blog (Phase 5) ───────────────────────────────────────────────────────────
export function listBlogPosts({ limit = 20, skip = 0, tag } = {}) {
  const qs = new URLSearchParams({ limit, skip });
  if (tag) qs.set('tag', tag);
  return request(`/api/blog/posts?${qs.toString()}`);
}

export function getBlogPost(slug) {
  return request(`/api/blog/posts/${encodeURIComponent(slug)}`);
}

export function listBlogTags() {
  return request('/api/blog/tags');
}

export function adminListBlogPosts() {
  return request('/api/blog/admin/posts');
}

export function adminGetBlogPost(id) {
  return request(`/api/blog/admin/posts/${id}`);
}

export function adminCreateBlogPost(payload) {
  return request('/api/blog/admin/posts', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function adminUpdateBlogPost(id, payload) {
  return request(`/api/blog/admin/posts/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function adminDeleteBlogPost(id) {
  return request(`/api/blog/admin/posts/${id}`, { method: 'DELETE' });
}

// ─── National rollout waitlist ───────────────────────────────────────────────
export function getWaitlistRegions() {
  return request('/api/waitlist/regions');
}

export function joinWaitlist(payload) {
  return request('/api/waitlist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}
